import { Injectable } from '@angular/core';
import { HttpService } from 'services/http.service';
import { ServiceBase } from 'services/servicebase';
import { environment } from '../../../environments/environment';
import { ExitInverviewSettingModel } from 'services/models/offboarding/exitInterviewSetting.model';
import { Response } from 'services/models/response';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ExitInterviewSettingService extends ServiceBase<ExitInverviewSettingModel> {
  constructor(http: HttpService) {
    super('exitInterview/settings', http, environment.apiUrl);
  }

  createEntity(input: any): ExitInverviewSettingModel {
    return ExitInverviewSettingModel.create(input);
  }

  getSetting(): Observable<Response<ExitInverviewSettingModel>> {
    return this.http.get(`${this.endpoint}`, undefined, this.baseUrl, undefined, true).pipe(
      map(res => {
        const response = new Response<ExitInverviewSettingModel>();
        response.data = this.createEntity(res.body || {}) as ExitInverviewSettingModel;
        return response;
      })
    );
  }

  public createOrUpdate(object: ExitInverviewSettingModel): Observable<any> {
    if (object.id && object.id !== '') {
      return this.http.put(this.endpoint, object, true);
    } else {
      return this.http.post(this.endpoint, object, null, null, true);
    }
  }
}
